import { pushDataLayerEvent } from "../shared/utils/metricManagementUtil"

export const registerStepDatalayer = ({ category, label }) => {
  pushDataLayerEvent({
    event: "Interacciones - Registro",
    category,
    action: "click",
    label,
    Location: window.location.href,
  })
}
